export const PRIVACY_POLICY_LINKS = {
  es: "https://spradling.group/es-la/paginas/politica-de-privacidad",
  en: "https://spradling.group/en-us/pages/privacy-policy"
}
